import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { successAlert, errorAlert } from "../Alerts/actions";
import api from "../../utils/api";
import QueryString from "query-string";
import {
  FETCH_BLOGS,
  GET_VIEW_DATA,
  ADD_BLOGS,
  EDIT_BLOGS,
  DELETE_BLOGS,
} from "./constants";
import {
  fetchBlogs as fetchBlogsAction,
  fetchBlogsSuccess,
  fetchBlogsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataSuccess,
  getViewDataFailure,
  //
  addBlogsSuccess,
  addBlogsFailure,
  //
  editBlogsSuccess,
  editBlogsFailure,
  //
  deleteBlogsSuccess,
  deleteBlogsFailure,
} from "./actions";

export function* fetchBlogsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/blogs?${query}`);
    yield put(fetchBlogsSuccess(data));
  } catch (e) {
    yield put(fetchBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching news!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/blogs/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/blogs/add`, payload.data);
    if (data) {
      yield put(successAlert("Blogs added successfully!"));
      yield put(addBlogsSuccess());
      if (payload?.history) {
        payload.history.push("/d/blogs");
      }
    }
  } catch (e) {
    yield put(addBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/blogs/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Blogs updated successfully!"));
      yield put(editBlogsSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/blogs/${payload}`);
    if (data) {
      yield put(successAlert("Blogs deleted successfully!"));
      yield put(deleteBlogsSuccess());
      yield put(fetchBlogsAction());
    }
  } catch (e) {
    yield put(deleteBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchBlogsFlow() {
  yield takeEvery(FETCH_BLOGS, fetchBlogsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addBlogsFlow() {
  yield takeEvery(ADD_BLOGS, addBlogsSaga);
}
export function* editBlogsFlow() {
  yield takeEvery(EDIT_BLOGS, editBlogsSaga);
}
export function* deleteBlogsFlow() {
  yield takeEvery(DELETE_BLOGS, deleteBlogsSaga);
}
export default function* BlogsSaga() {
  yield all([
    fetchBlogsFlow(),
    addBlogsFlow(),
    editBlogsFlow(),
    deleteBlogsFlow(),
    getViewDataFlow(),
  ]);
}
